import Button from "components/button";
import Loading from "components/center-loading";
import Checkbox from "components/checkbox";
import DeadlineControl from "components/deadline-control";
import Input from "components/input";
import InputNumber from "components/input-number";
import TextArea from "components/textarea";
import { SelectBox } from "components/uikit-adapter";
import { parseFloatByLocale } from "locales/utils";
import Dialog from "material-ui/Dialog";
import MenuItem from "material-ui/MenuItem";
import SelectField from "material-ui/SelectField";
import SnackBar from "material-ui/Snackbar";
import moment from "moment";
import PropTypes from "prop-types";
import { Component } from "react";
import { Col, Row } from "react-flexbox-grid";
import intl from "react-intl-universal";
import { fetchSuggestionsJustifications } from "services/suggestion/suggestion.service";
import { fetchSupplierForOrder } from "services/supplier.service";
import { compareDates } from "utils/date";
import { formatErrorMessage } from "utils/handle-error";
import SessionUser from "utils/user-storage";
import { userFornecedor } from "services/permissions/getPermissions";
import { useAllowUserToSkipSupplierApproval } from "utils/validations-general-settings";
import CompositionOrders from "../compositon-orders";
import { anticipateDelayOrder } from "./inform-advance-delay-order.service";
import StyledInformAdvanceDelayOrder from "./inform-advance-delay-order.styled";
import InformationOrder from "./information-orders";

class InformAdvanceDelayOrder extends Component {
  constructor(props) {
    super(props);

    this.state = {
      novaDataColeta: "",
      novaDataEntrega: "",
      horaEntrega: null,
      textMsg: "",
      observacao: "",
      showMsg: false,
      isFetching: false,
      showCompositionOrders: false,
      quantidade: "",
      supplierId: null,
      origins: [],
      skipSupplierApproval: false,
      selectedMessage: null,
      listaJustificativasSugestaoManual: [],
    };
  }
  componentDidMount = () => {
    this.getSuppliers();
    this.obterListaJustificativasSugestaoManual();
  };

  getDefaultJustificationMessage = (data) => (data && data.length > 0 ? data[0].Key : 0);

  changeValue = (event) => {
    const prop = event.target.name;
    const value = event.target.value;

    this.setState({
      [prop]: value,
    });
  };

  onChangeSelectedMessage = (_selectedValues, _idx, value) => {
    const selectedMessage = value;
    this.setState({ selectedMessage });
  };

  proccessError = (message) => {
    this.setState({
      showMsg: true,
      textMsg: message,
    });
  };

  finalizeProccessError = () => {
    this.setState({
      showMsg: false,
      textMsg: "",
    });
  };

  startFetching() {
    this.setState({
      isFetching: true,
    });
  }

  stopFetching() {
    this.setState({
      isFetching: false,
    });
  }

  validateEnteredData = (dataColetaAtual, dataEntregaAtual, dataColeta, dataEntrega) => {
    const { novaDataColeta, novaDataEntrega, observacao, quantidade } = this.state;

    if (!novaDataColeta && !novaDataEntrega && !quantidade) {
      this.proccessError(intl.get("stocks.informAdvanceOrder.feedback.enterLeastOnePropertie"));
      return false;
    } else if (!observacao) {
      this.proccessError(
        intl.get("stocks.informAdvanceOrder.feedback.observationFieldIsMandatory")
      );
      return false;
    } else if (parseFloatByLocale(quantidade) === 0) {
      this.proccessError(intl.get("stocks.informAdvanceOrder.feedback.quantityCannotBeZero"));
      return false;
    } else if (
      !!novaDataColeta &&
      compareDates(novaDataColeta, moment().format("YYYY-MM-DD")) < 0
    ) {
      this.proccessError(
        intl.get("stocks.informAdvanceOrder.feedback.collectionDateCannotEarlierThanCurrentDay")
      );
      return false;
    } else if (
      !!novaDataEntrega &&
      compareDates(novaDataEntrega, moment().format("YYYY-MM-DD")) < 0
    ) {
      this.proccessError(
        intl.get("stocks.informAdvanceOrder.feedback.deliverynDateCannotEarlierThanCurrentDay")
      );
      return false;
    } else if (compareDates(dataColeta, dataEntrega) > 0) {
      this.proccessError(
        intl.get("stocks.informAdvanceOrder.feedback.collectionDateCannotBegreaterThanDeliveryDate")
      );
      return false;
    } else if (
      compareDates(novaDataColeta, dataColetaAtual) === 0 &&
      compareDates(novaDataEntrega, dataEntregaAtual) === 0
    ) {
      this.proccessError(
        intl.get("stocks.informAdvanceOrder.feedback.collectionAndDeliveryDateAreSamePrevious")
      );
      return false;
    } else if (compareDates(novaDataColeta, dataColetaAtual) === 0 && !novaDataEntrega) {
      this.proccessError(
        intl.get("stocks.informAdvanceOrder.feedback.collectionDateIsSameAsPrevious")
      );
      return false;
    } else if (compareDates(novaDataEntrega, dataEntregaAtual) === 0 && !novaDataColeta) {
      this.proccessError(
        intl.get("stocks.informAdvanceOrder.feedback.deliveryDateIsSameAsPrevious")
      );
      return false;
    }

    return true;
  };

  save = () => {
    const { novaDataColeta, novaDataEntrega } = this.state;
    const { pedido } = this.props;
    const dataColetaAtual = moment(pedido.DataColeta, "DD/MM/YYYY").format("YYYY-MM-DD");
    const dataEntregaAtual = moment(pedido.DataEntrega, "DD/MM/YYYY").format("YYYY-MM-DD");
    const dataColeta = novaDataColeta || dataColetaAtual;
    const dataEntrega = novaDataEntrega || dataEntregaAtual;

    const isEnteredDataValid = this.validateEnteredData(
      dataColetaAtual,
      dataEntregaAtual,
      dataColeta,
      dataEntrega
    );

    this.setState({
      showCompositionOrders: isEnteredDataValid,
    });
  };

  handleConfirm = async () => {
    try {
      this.startFetching();

      const user = SessionUser.get().Id;
      const {
        novaDataColeta,
        novaDataEntrega,
        observacao,
        horaEntrega,
        quantidade,
        skipSupplierApproval,
      } = this.state;
      const orderId = this.props.pedido.NumeroPedido;

      const body = {
        orderId: orderId,
        userId: user,
        collectionDate: novaDataColeta,
        deliveryDate: novaDataEntrega,
        deliveryTime: horaEntrega,
        quantity: parseFloatByLocale(quantidade),
        observation: observacao,
        ...(this.allowUserToSkipSupplierApproval() ? { skipSupplierApproval } : {}),
        justification: this.state.selectedMessage,
      };

      await anticipateDelayOrder(body);

      this.props.onSave();
    } catch (error) {
      this.proccessError(formatErrorMessage(error));
      throw error;
    } finally {
      this.stopFetching();
    }
  };

  changeValueDeadline = (coleta, entrega, item) => {
    this.setState({
      novaDataColeta: coleta,
      novaDataEntrega: entrega,
    });
  };

  changeValueHoraEntrega = (event) => {
    this.setState({
      horaEntrega: event.target.value,
    });
  };

  changeValueQuantity = (value) => {
    this.setState({
      quantidade: value,
    });
  };

  getSuppliers = async () => {
    const response = await fetchSupplierForOrder(this.props.pedido.NumeroPedido);
    this.setState({
      origins: response,
      supplierId: this.props.pedido.IdFornecedor,
    });
  };

  allowUserToSkipSupplierApproval = () => {
    const { pedido } = this.props;

    return (
      useAllowUserToSkipSupplierApproval() &&
      !userFornecedor() &&
      pedido.NegociacaoPedido !== false &&
      !pedido.IsBreweryTransfer &&
      !!pedido.NumeroPedidoSap &&
      [1, 2].includes(pedido.TipoPedido)
    );
  };

  async obterListaJustificativasSugestaoManual() {
    try {
      const data = await fetchSuggestionsJustifications();
      this.setState({
        listaJustificativasSugestaoManual: data,
        selectedMessage: this.getDefaultJustificationMessage(data),
      });
    } catch (err) {
      this.proccessError(`Erro: ${err?.response?.data ? err.response.data.Message : ""}`);
    }
  }

  render() {
    const { open, onClose, pedido } = this.props;
    const {
      isFetching,
      showMsg,
      textMsg,
      novaDataColeta,
      novaDataEntrega,
      observacao,
      showCompositionOrders,
      horaEntrega,
      quantidade,
      supplierId,
      origins,
      selectedMessage,
      listaJustificativasSugestaoManual,
    } = this.state;

    return (
      <div width="100%" height="100%">
        <Loading isLoading={isFetching} />

        <Dialog
          title={intl.get("stocks.informAdvanceOrder.informAnticipationDelay")}
          contentStyle={{ width: "680px" }}
          open={open}
          onRequestClose={onClose}
          autoScrollBodyContent
        >
          <StyledInformAdvanceDelayOrder>
            <label className="label-style">
              {intl.get("stocks.informAdvanceOrder.orderInformation")}
            </label>
            <div className="container">
              <InformationOrder pedido={pedido} />
            </div>
            <Row>
              <Col xs={8}>
                <SelectBox
                  label={intl.get("commons.source")}
                  placeholder={intl.get("commons.source")}
                  name="familiaRotulada"
                  style={{ height: "45px" }}
                  value={supplierId}
                  options={origins}
                  valueKey="Id"
                  labelKey="Description"
                  onChange={(value) => this.setState({ supplierId: value?.Id })}
                  searchable
                  openOnFocus
                  clearable
                  disabled
                />
              </Col>
              <Col xs={4}>
                <InputNumber
                  type="default"
                  label={intl.get("stocks.informAdvanceOrder.quantity")}
                  value={quantidade}
                  onChange={(value) => this.changeValueQuantity(value)}
                  allowDecimals
                  decimalsLimit={3}
                  className="inform-advance-order-quantity"
                  disabled={pedido.DesabilitarQuantidade}
                />
              </Col>
            </Row>
            <Row>
              <Col xs={8}>
                <DeadlineControl
                  TransitTime={pedido.TransitTime}
                  OnChange={(coleta, entrega) => this.changeValueDeadline(coleta, entrega, pedido)}
                  Coleta={novaDataColeta}
                  DataEntregaDe={novaDataEntrega}
                  TituloColeta={intl.get("stocks.informAdvanceOrder.newCollectionDate")}
                  TituloEntrega={intl.get("stocks.informAdvanceOrder.newDeliveryDate")}
                  ColetaDisabled={pedido.DesabilitarDataColeta}
                  CadeadoDisabled={pedido.DesabilitarDataColeta}
                  Identificador={`antecipacao-atraso-pedido-` + pedido.NumeroPedido}
                />
              </Col>
              <Col xs={4} style={{ paddingTop: "5px" }}>
                <Input
                  label={intl.get("stocks.informAdvanceOrder.newDeliveryTime")}
                  name="HoraEntrega"
                  htmlType="time"
                  value={horaEntrega}
                  onChange={(event) => this.changeValueHoraEntrega(event)}
                  className="txtHoraEntrega"
                />
              </Col>
            </Row>

            <Row>
              <Col xs={12}>
                <TextArea
                  name="observacao"
                  label={intl.get("commons.observation")}
                  value={observacao || ""}
                  onChange={this.changeValue}
                  className="txtObservacao"
                />
              </Col>
            </Row>

            {(!!quantidade || !!novaDataEntrega) && !!listaJustificativasSugestaoManual && (
              <div className="select-dropdown">
                <SelectField
                  floatingLabelText={intl.get("stocks.suggestionsListItem.justification")}
                  value={selectedMessage}
                  onChange={this.onChangeSelectedMessage}
                  fullWidth={true}
                >
                  {listaJustificativasSugestaoManual?.map((v) => (
                    <MenuItem value={v.Key} key={v.Key} primaryText={v.Value} />
                  ))}
                </SelectField>
              </div>
            )}

            {this.allowUserToSkipSupplierApproval() && (
              <Row>
                <Col xs={12} style={{ paddingTop: "5px" }}>
                  <Checkbox
                    text={intl.get("stocks.informAdvanceOrder.skipSupplierApproval")}
                    name="checkbox-skip-supplier-approval"
                    checked={this.state.skipSupplierApproval || false}
                    onChange={() => {
                      this.setState((prevState) => ({
                        skipSupplierApproval: !prevState.skipSupplierApproval,
                      }));
                    }}
                  />
                  {this.state.skipSupplierApproval && (
                    <span>{intl.get("stocks.informAdvanceOrder.skipSupplierApprovalWarning")}</span>
                  )}
                </Col>
              </Row>
            )}

            <div className="footer-dialog-buttons">
              <Button
                buttonType="default"
                htmlType="button"
                value={intl.get("geral.buttonsDefault.close")}
                onClick={onClose}
                className="button btn-close"
              />
              <Button
                buttonType="primary"
                value={intl.get("geral.buttonsDefault.save")}
                className="button btn-save"
                disabled={isFetching}
                onClick={this.save}
              />
            </div>

            <SnackBar
              message={textMsg}
              open={showMsg}
              autoHideDuration={6000}
              onRequestClose={this.finalizeProccessError}
              style={{
                width: "100%",
                textAlign: "center",
                display: "flex",
                justifyContent: "center",
              }}
              bodyStyle={{
                height: "auto",
                lineHeight: "1.5",
                padding: "12px 24px",
                whiteSpace: "normal",
              }}
            />
          </StyledInformAdvanceDelayOrder>
        </Dialog>

        {showCompositionOrders && (
          <CompositionOrders
            pedido={pedido}
            onClose={onClose}
            handleConfirm={this.handleConfirm}
            message={intl.get("stocks.timeline.feedback.messageCompositionOrders2")}
          />
        )}
      </div>
    );
  }
}

InformAdvanceDelayOrder.propTypes = {
  open: PropTypes.bool.isRequired,
  pedido: PropTypes.object,
  onClose: PropTypes.func.isRequired,
  onSave: PropTypes.func.isRequired,
  labeledFamilyCenterPeriodicity: PropTypes.bool,
};

export default InformAdvanceDelayOrder;
